export default "__VITE_ASSET__49d5d797__"